import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box } from "@mui/system";

export default function AccordionFaqs({ faqsData }) {
  const [expanded, setExpanded] = React.useState<string | false>("panel0");

  const handleChange =
    (panel: string) => (_: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <>
      {faqsData.map((data, index) => (
        <Box key={index} sx={{ marginTop: "1rem" }}>
          <Accordion
            expanded={expanded === `panel${index}`}
            onChange={handleChange(`panel${index}`)}
            sx={{
              borderRadius: "8px",
              border: "1px solid #E5E5E5",
              boxShadow: "none",
              padding: "16px 20px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "#0A0A0A" }} />}
            >
              <Typography fontSize={20} component="span" fontWeight={600}>
                {data.title}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography fontSize={16} fontWeight={"normal"} component="span">
                {data.content}
              </Typography>
            </AccordionDetails>
          </Accordion>
        </Box>
      ))}
    </>
  );
}
